var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderAnim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 163,
    viewBox: "0 0 172 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.152 110.02C100.152 110.02 116.882 128.41 106.021 132.149C95.1598 135.887 89.2907 113.759 89.2907 113.759L100.152 110.02Z",
    fill: "url(#paint0_radial_638_990)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.075 129.817C107.983 130.441 106.782 130.854 105.537 131.032C102.486 131.457 99.3257 130.482 96.8755 128.634C96.5851 128.402 96.2817 128.186 95.9668 127.988C98.5878 131.322 101.954 133.548 106.021 132.149C107.537 131.627 108.514 130.819 109.075 129.817Z",
    fill: "#FFADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9273 98.5388C56.9273 98.5388 60.136 104.285 56.2964 107.204C52.4568 110.123 23.403 111.303 21.584 105.994C19.7651 100.685 55.6309 94.4636 56.9273 98.5388Z",
    fill: "url(#paint1_radial_638_990)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2935 72.0534C97.2935 72.0534 100.702 77.6834 105.136 75.7863C109.57 73.8892 124.951 49.2039 121.235 44.9986C117.519 40.7933 94.3922 68.9125 97.2935 72.0534Z",
    fill: "url(#paint2_radial_638_990)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.364 45.8864C114.364 45.8864 122.461 66.6471 123.082 66.8852C123.703 67.1234 124.565 66.7412 125.017 66.4585C125.469 66.1758 117.262 44.2319 117.262 44.2319L114.364 45.8864Z",
    fill: "#ED7218"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.071 45.4816C128.539 39.5654 131.442 27.1328 125.556 17.7126C119.669 8.29233 107.222 5.45173 97.7544 11.3679C88.2865 17.2841 85.3832 29.7167 91.2696 39.1369C97.156 48.5571 109.603 51.3977 119.071 45.4816Z",
    fill: "#FF3381"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.604 29.5312C90.8881 23.5597 94.5178 17.7079 99.3794 14.1261C102.99 11.4659 107.197 9.82651 111.51 8.51314C108.63 8.08032 105.687 8.27545 102.884 9.08511C100.081 9.89477 97.484 11.2998 95.2719 13.2035C93.0598 15.1072 91.2849 17.4645 90.0693 20.1132C88.8538 22.762 88.2263 25.6394 88.2302 28.5476C88.234 31.4559 88.869 34.3259 90.0915 36.9605C91.314 39.595 93.0951 41.9316 95.3121 43.8095C97.5292 45.6873 100.13 47.062 102.935 47.839C105.74 48.6159 108.684 48.7767 111.563 48.3103C108.421 48.2006 105.362 47.3001 102.669 45.6925C98.6014 43.2774 95.473 39.4698 93.4116 35.2172C92.5402 33.4198 91.842 31.5162 91.604 29.5312Z",
    fill: "#FF73A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.058 28.541C126.78 30.312 125.879 32.275 124.782 34.1655C123.478 36.413 121.587 38.3529 119.599 39.9817C115.783 43.1089 110.36 46.0768 105.266 44.8606C100.172 43.6445 97.1026 38.3341 96.3412 33.4985C95.5731 28.6159 96.3938 21.811 100.451 18.6321C104.272 15.6388 111.541 15.4538 115.786 17.7924C120.645 20.469 120.466 27.3569 117.61 31.2209C114.42 35.5366 106.529 38.3435 102.756 33.2114C99.4726 28.7469 102.434 22.9331 107.574 22.3114C109.867 22.034 112.378 23.206 113.394 25.3796C114.042 26.7687 113.685 28.3075 112.488 29.1837C110.593 30.5713 108.203 28.4443 108.972 26.2919C108.988 26.2574 108.991 26.2177 108.978 26.1816C108.966 26.1454 108.939 26.1158 108.905 26.0991C108.87 26.0825 108.831 26.0803 108.794 26.0929C108.758 26.1055 108.728 26.132 108.711 26.1665C107.156 28.937 110.563 31.6865 113.123 30.109C116.914 27.7743 115.034 23.0368 111.853 21.1111C108.432 19.0405 104.035 20.5218 101.471 23.106C98.5801 26.019 98.9222 30.5435 100.684 33.9991C103.001 38.5426 107.906 39.4202 112.336 38.3115C117.161 37.1039 121.107 33.3055 122.603 28.5579C124.052 23.9607 122.622 19.1238 119.132 15.7996C115.527 12.3655 109.41 12.2476 104.895 13.0591C101.578 13.6553 98.6033 15.1784 96.4861 17.8332C94.3381 20.5275 93.6236 24.2963 93.2346 27.6611C92.4581 34.3788 94.4868 41.4628 100.092 45.6531C106.042 50.1013 112.855 48.1805 118.6 44.7138C120.835 43.3652 123.459 41.3349 125.566 38.9139C127.493 35.6984 128.5 32.0207 128.479 28.2819C128.394 28.2927 128.313 28.3214 128.24 28.3661C128.168 28.4108 128.106 28.4704 128.058 28.541Z",
    fill: "#FF73A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.175 28.7297C126.886 30.4828 125.969 32.42 124.858 34.2883C123.538 36.5095 121.638 38.4348 119.646 40.0572C115.821 43.1706 110.403 46.1467 105.36 45.0111C100.316 43.8755 97.3298 38.6984 96.6296 33.9604C95.9232 29.1767 96.816 22.4873 100.881 19.3204C104.709 16.3381 111.927 16.073 116.115 18.3197C120.909 20.8911 120.652 27.6544 117.772 31.4803C114.555 35.7533 106.689 38.5991 103.002 33.6048C99.793 29.2602 102.8 23.5192 107.91 22.85C110.19 22.5514 112.67 23.6729 113.653 25.7947C114.281 27.151 113.908 28.6655 112.71 29.5393C110.813 30.9236 108.464 28.8627 109.252 26.7412C109.267 26.7073 109.268 26.6689 109.255 26.6343C109.242 26.5997 109.216 26.5716 109.183 26.5559C109.149 26.5402 109.111 26.5383 109.076 26.5504C109.041 26.5626 109.012 26.5879 108.995 26.621C107.419 29.3585 110.77 32.0182 113.33 30.4404C117.12 28.1044 115.309 23.4764 112.172 21.6225C108.8 19.6293 104.417 21.1339 101.842 23.7001C98.9383 26.5928 99.2259 31.0301 100.936 34.4018C103.184 38.8351 108.043 39.6402 112.454 38.5008C117.258 37.2601 121.219 33.4866 122.759 28.8085C124.25 24.2792 122.887 19.5477 119.46 16.3247C115.92 12.9952 109.849 12.9498 105.357 13.7982C102.056 14.4216 99.0854 15.9504 96.9532 18.5813C94.7896 21.2506 94.0368 24.9581 93.6121 28.2658C92.7642 34.8691 94.6967 41.7991 100.213 45.8481C106.069 50.146 112.855 48.1821 118.599 44.7133C120.834 43.3637 123.462 41.3406 125.582 38.9399C127.525 35.7857 128.567 32.1647 128.596 28.4698C128.512 28.4815 128.431 28.5108 128.358 28.5555C128.286 28.6003 128.224 28.6596 128.175 28.7297Z",
    fill: "#C40E7F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9911 116.648C71.9911 116.648 56.7097 136.391 67.8187 139.2C78.9278 142.009 83.1003 119.457 83.1003 119.457L71.9911 116.648Z",
    fill: "url(#paint3_radial_638_990)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1239 117.531C82.1239 117.531 77.9588 142.091 89.106 139.328C100.253 136.566 93.2709 114.768 93.2709 114.768L82.1239 117.531Z",
    fill: "url(#paint4_radial_638_990)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.251 94.6144C107.251 94.6144 131.695 89.5342 129.349 100.751C127.004 111.967 104.905 105.831 104.905 105.831L107.251 94.6144Z",
    fill: "url(#paint5_radial_638_990)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.604 104.109C103.604 104.109 127.505 111.132 120.135 119.94C112.765 128.748 96.2345 112.917 96.2345 112.917L103.604 104.109Z",
    fill: "url(#paint6_radial_638_990)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.129 69.4919C115.477 80.446 114.602 92.5018 111.018 103.786C108.843 110.634 106.067 117.892 99.8689 121.765C93.6704 125.639 85.9307 124.951 78.8218 123.904C67.1085 122.18 55.8891 117.681 48.3882 108.072C34.9765 90.8889 30.2584 58.3153 51.8067 44.8498C73.3549 31.3842 100.565 49.9051 110.129 69.4919Z",
    fill: "url(#paint7_radial_638_990)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.9541 58.6803C97.1973 62.6409 98.1084 66.7574 98 70.9122C97.9156 74.1401 97.218 77.3241 96.3729 80.4446C93.924 89.4873 90.0571 98.4127 83.4341 105.067C76.811 111.721 66.9174 116.469 57.7555 114.515C56.6517 114.279 54.7532 113.789 53.6683 113.461C60.1516 118.93 68.1108 121.927 76.5541 123.433C79.7506 122.367 83.9067 120.4 86.8049 118.699C98.3684 111.91 107.852 101.375 112.585 88.8566C113.076 87.5568 113.507 86.2342 113.89 84.8979C113.696 79.6528 112.554 74.4592 110.129 69.4924C106.353 61.7593 99.8254 54.1943 91.9827 48.6962C93.5495 51.9219 94.8769 55.2589 95.9541 58.6803Z",
    fill: "#5D0D75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.3693 72.7027C39.4259 64.73 42.3462 56.8168 47.3813 50.6035C50.0809 47.2936 53.3285 44.4689 56.9824 42.2528C55.179 42.9527 53.4459 43.8223 51.8065 44.8499C30.2576 58.3151 34.976 90.8892 48.3885 108.072C55.3698 117.015 65.5722 121.53 76.3958 123.504C65.5782 118.164 54.5729 112.17 48.1004 102.096C45.5849 98.179 43.8727 93.8015 42.4397 89.3712C40.6942 83.9739 39.3292 78.3808 39.3693 72.7027Z",
    fill: "#FFADEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5156 97.0952C64.5156 97.0952 91.7022 110.767 94.297 78.4858C94.297 78.4858 78.5743 95.0832 64.5156 97.0952Z",
    fill: "#5D0D75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.0986 138.707C67.0989 136.569 66.0225 133.627 66.0448 130.696C66.0588 128.857 66.4822 127.047 66.9034 125.254L67.1984 123.999C63.9186 129.924 61.2344 137.535 67.8179 139.199C68.4834 139.371 69.1696 139.451 69.8577 139.438C69.5924 139.208 69.339 138.963 69.0986 138.707Z",
    fill: "#FFADEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.184 136.945C83.949 134.16 82.4799 130.854 81.366 127.447C81.4331 133.729 82.8082 140.488 88.6052 139.437C87.7214 138.684 86.9107 137.85 86.184 136.945Z",
    fill: "#FFADEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M118.684 114.71C119.575 116.091 120.251 117.599 120.692 119.183C123.902 114.207 117.405 109.864 111.52 107.134C114.187 109.402 116.801 111.773 118.684 114.71Z",
    fill: "#FFADEF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.35 100.751C130.738 94.1143 122.747 93.1834 115.99 93.5293C118.969 94.2692 121.825 95.5033 124.277 97.3304C126.103 98.6843 127.656 100.37 128.856 102.299C129.074 101.801 129.24 101.283 129.35 100.751Z",
    fill: "#FFADEF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5731 75.9854C55.4711 71.6751 57.6742 62.7577 53.4939 56.0679C49.3137 49.3781 40.333 47.4492 33.4351 51.7595C26.5372 56.0698 24.3341 64.9871 28.5143 71.6769C32.6946 78.3667 41.6752 80.2957 48.5731 75.9854Z",
    fill: "#FFADEF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8009 74.7496C54.6988 70.4393 57.0748 61.7986 53.1078 55.45C49.1408 49.1015 40.333 47.4492 33.4351 51.7595C26.5372 56.0698 24.1612 64.7105 28.1282 71.059C32.0952 77.4076 40.903 79.0599 47.8009 74.7496Z",
    fill: "#5D0D75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.494 72.4472C52.047 68.3524 54.52 60.4892 51.0176 54.8842C47.5152 49.2791 39.3637 48.0549 32.8107 52.1497C26.2576 56.2445 23.7846 64.1077 27.287 69.7127C30.7894 75.3177 38.9409 76.542 45.494 72.4472Z",
    fill: "url(#paint8_radial_638_990)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.4935 72.4467C52.0466 68.3518 54.5201 60.4891 51.0174 54.8835C50.2431 53.6473 49.2177 52.5874 48.0069 51.7719C48.0957 52.795 48.0361 53.8262 47.8298 54.8337C47.2212 57.7883 45.5215 60.4187 43.5426 62.7042C40.9841 65.6596 37.8276 68.2061 34.1277 69.4698C32.0282 70.1939 29.7935 70.4335 27.5922 70.1705C31.244 75.3805 39.1231 76.4274 45.4935 72.4467Z",
    fill: "#DBA75C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2767 68.1594C45.691 66.6508 46.4893 63.5733 45.0598 61.2855C43.6303 58.9978 40.5143 58.3662 38.1 59.8749C35.6857 61.3835 34.8874 64.461 36.3169 66.7487C37.7464 69.0364 40.8625 69.668 43.2767 68.1594Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2133 67.384C44.3976 66.0191 45.1544 63.2898 43.9036 61.2881C42.6527 59.2863 39.868 58.7701 37.6836 60.135C35.4993 61.4999 34.7425 64.2292 35.9934 66.2309C37.2442 68.2327 40.029 68.7489 42.2133 67.384Z",
    fill: "#574120"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9515 61.5586C37.5654 60.5508 36.4322 60.0498 35.4204 60.4395C34.4086 60.8293 33.9013 61.9623 34.2873 62.9701C34.6734 63.9779 35.8066 64.479 36.8184 64.0892C37.8302 63.6994 38.3375 62.5665 37.9515 61.5586Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0152 57.6786C45.2647 55.9076 44.8434 53.4677 43.0741 52.229C41.3048 50.9903 38.8576 51.4217 37.6081 53.1927C36.3586 54.9637 36.78 57.4036 38.5492 58.6423C40.3185 59.8811 42.7657 59.4496 44.0152 57.6786Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6065 55.9677C87.5045 51.6574 89.7076 42.74 85.5274 36.0502C81.3471 29.3604 72.3664 27.4315 65.4684 31.7418C58.5704 36.0522 56.3673 44.9695 60.5475 51.6593C64.7278 58.3492 73.7085 60.2781 80.6065 55.9677Z",
    fill: "#FFADEF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8342 54.7319C86.7322 50.4216 89.1083 41.7808 85.1413 35.4323C81.1743 29.0838 72.3664 27.4315 65.4684 31.7418C58.5704 36.0522 56.1944 44.6929 60.1614 51.0414C64.1284 57.39 72.9363 59.0423 79.8342 54.7319Z",
    fill: "#5D0D75"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5272 52.4296C84.0802 48.3348 86.5532 40.4716 83.0508 34.8666C79.5484 29.2616 71.3969 28.0373 64.8439 32.1321C58.2908 36.2269 55.8178 44.0901 59.3202 49.6952C62.8226 55.3002 70.9741 56.5244 77.5272 52.4296Z",
    fill: "url(#paint9_radial_638_990)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.5269 52.4295C84.0798 48.3348 86.5533 40.472 83.0506 34.8665C82.2763 33.6302 81.2509 32.5704 80.0401 31.7548C80.129 32.778 80.0695 33.8093 79.8634 34.8169C79.2546 37.7716 77.555 40.4019 75.5761 42.6875C73.0175 45.6429 69.861 48.1894 66.1611 49.453C64.0616 50.1772 61.827 50.4168 59.6256 50.1538C63.278 55.363 71.1568 56.41 77.5269 52.4295Z",
    fill: "#DBA75C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3099 48.1418C77.7242 46.6332 78.5225 43.5557 77.093 41.268C75.6635 38.9802 72.5475 38.3487 70.1332 39.8573C67.7189 41.3659 66.9206 44.4434 68.3501 46.7312C69.7796 49.0189 72.8957 49.6505 75.3099 48.1418Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2465 47.3664C76.4309 46.0015 77.1876 43.2723 75.9368 41.2705C74.6859 39.2688 71.9012 38.7525 69.7168 40.1174C67.5325 41.4824 66.7757 44.2116 68.0266 46.2134C69.2774 48.2151 72.0622 48.7314 74.2465 47.3664Z",
    fill: "#574120"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9625 41.4866C69.5462 40.4909 68.3983 40.0241 67.3985 40.444C66.3987 40.8639 65.9256 42.0115 66.3419 43.0072C66.7582 44.0029 67.9062 44.4697 68.906 44.0498C69.9058 43.6299 70.3788 42.4823 69.9625 41.4866Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9111 37.845C77.2622 36.1497 76.985 33.6887 75.2921 32.3483C73.5991 31.0079 71.1314 31.2956 69.7803 32.9909C68.4293 34.6862 68.7064 37.1472 70.3994 38.4876C72.0924 39.828 74.56 39.5403 75.9111 37.845Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9709 95.6034C69.9709 95.6034 69.7323 100.745 71.1301 101.668C72.528 102.592 77.9565 100.506 78.4158 99.4021C78.8751 98.2978 76.1521 92.8837 76.1521 92.8837C76.1521 92.8837 71.3714 95.2174 69.9709 95.6034Z",
    fill: "#FFF5DE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0174 82.4232C90.0174 82.4232 94.9743 84.3183 95.1914 85.9796C95.4085 87.6408 91.1546 91.6058 89.9607 91.5345C88.7668 91.4631 84.8632 86.7868 84.8632 86.7868C84.8632 86.7868 89.0567 83.5137 90.0174 82.4232Z",
    fill: "#FFF5DE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9885 18.9989C91.2058 18.0687 90.6269 17.1423 89.6956 16.9298C88.7643 16.7173 87.8332 17.2991 87.616 18.2293C87.3988 19.1595 87.9776 20.0859 88.9089 20.2984C89.8402 20.5109 90.7713 19.9291 90.9885 18.9989Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-447.989 233.85) rotate(-168.286) scale(23.8406 47.8242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-170.218 73.496) rotate(-135.944) scale(64.8063 26.7463)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-64.7904 -115.638) rotate(-107.088) scale(70.0822 24.734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2212 140.527) rotate(-32) scale(33.867 33.6804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.686 35.4038) rotate(-57.4456) scale(33.0617 34.5024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-115.908 239.4) rotate(148) scale(33.8674 33.6804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-254.267 237.314) rotate(173.446) scale(33.0617 34.5024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.2717 63.0142) rotate(-32) scale(57.996 57.6834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7332 57.044) rotate(-32) scale(30.0092 29.8462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_638_990",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.7538 37.0343) rotate(-32) scale(30.0092 29.8462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderAnim);
export default __webpack_public_path__ + "static/media/headerAnim.4681338d2c4be03bcf1ad98d3096623e.svg";
export { ForwardRef as ReactComponent };